export default __webpack_public_path__ + "static/scoap3_logo-e31a9f78347c4f68e18a06148a6caa80.png";